import { render, staticRenderFns } from "./CrmTileLeadUi.vue?vue&type=template&id=d3136db6&scoped=true&lang=pug&"
import script from "./CrmTileLeadUi.vue?vue&type=script&lang=js&"
export * from "./CrmTileLeadUi.vue?vue&type=script&lang=js&"
import style0 from "./CrmTileLeadUi.vue?vue&type=style&index=0&id=d3136db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3136db6",
  null
  
)

export default component.exports